import { render } from "./rewardConfig.vue?vue&type=template&id=61a87cb6&ts=true"
import script from "./rewardConfig.vue?vue&type=script&lang=ts"
export * from "./rewardConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__